import React from "react";
import { CiidMap, CiidMapProps } from "./CiidMap";

export const GoogleMap = (props: CiidMapProps) => {
  return <CiidMap {...props} />;
};
